import React, { PropsWithChildren } from "react";

/**
 * This Layout component reflects the layout that can be shared between the
 * App Router and Pages Router pges. Anything added to this layout _must_ be
 * compatible with both patterns.
 */
const Layout: React.FC<PropsWithChildren> = ({ children }) => <>{children}</>;

export default Layout;
